const numeric = value => Number(String(value ?? 0).replace(',', '.')) || 0;

export const scanDiscountMode = item => item.korting_mode === 'euro' ? 'euro' : 'percent';
export const scanGross = (total, price) => numeric(total) * numeric(price);
export const scanDiscountValid = (item, gross) => {
  const value = Number(String(item.korting ?? 0).replace(',', '.'));
  return Number.isFinite(value) && value >= 0 && value <= (scanDiscountMode(item) === 'euro' ? Math.abs(gross) + 1e-9 : 100)
    && (scanDiscountMode(item) !== 'euro' || Math.abs(value * 100 - Math.round(value * 100)) < 1e-7);
};
export const scanDiscountPercent = (item, gross) => scanDiscountMode(item) === 'euro'
  ? (gross ? Math.min(100, numeric(item.korting) / Math.abs(gross) * 100) : 0) : numeric(item.korting);
export const scanDiscountedTotal = (item, gross) => scanDiscountMode(item) === 'euro'
  ? Math.sign(gross) * Math.max(0, Math.abs(gross) - numeric(item.korting))
  : gross * (1 - numeric(item.korting) / 100);

export function switchScanDiscount(item, mode, gross) {
  if (mode === scanDiscountMode(item)) return item;
  const value = mode === 'euro' ? Math.abs(gross) * numeric(item.korting) / 100
    : (gross ? numeric(item.korting) / Math.abs(gross) * 100 : 0);
  return { ...item, korting_mode: mode, korting: mode === 'euro'
    ? Math.min(Math.round(value * 100) / 100, Math.floor((Math.abs(gross) + 1e-9) * 100) / 100) : value };
}

// Standard documents retain a percentage for all existing reports/PDFs, plus the fixed euro source.
export function syncScanDocumentDiscount(line) {
  if (line.scan_korting_mode !== 'euro') return line;
  const gross = Math.abs(numeric(line.aantal) * numeric(line.prijs));
  const euro = numeric(line.scan_korting_euro);
  const percentage = gross ? euro / gross * 100 : 0;
  return Math.abs(numeric(line.korting) - percentage) < 1e-12 ? line : { ...line, korting: percentage };
}

export function scanDocumentDiscountValid(line) {
  return line.scan_korting_mode !== 'euro' || scanDiscountValid(
    { korting_mode: 'euro', korting: line.scan_korting_euro }, Math.abs(numeric(line.aantal) * numeric(line.prijs)));
}